export default __webpack_public_path__ + "static/media/loja6.9548ec8d.jpeg";